import { DataBean } from "../../DataBean";


export class HealthAllergies extends DataBean {


    public async getHealthAllergiesCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthAllergiesCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}